import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from 'next-themes';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import { InstallPrompt } from '@/components/pwa/install-prompt';
import { AuthProvider } from '@/hooks/use-auth';
import { router } from './routes/router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
        {/* AuthProvider is a singleton — one auth state shared by the whole app.
            Every useAuth() call reads from this context instead of creating its
            own independent subscription and state machine. */}
        <AuthProvider>
          <RouterProvider router={router} />
          <InstallPrompt />
          <Toaster
            position="top-right"
            toastOptions={{
              classNames: {
                toast: 'font-sans',
              },
            }}
          />
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
